// ----------------------------------------------------------------------------

function isVisible(element: HTMLElement): boolean {
    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}

// ----------------------------------------------------------------------------

export default isVisible;
